/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Text from '@mui/material/Typography';

export default function RadioColumn({
  options,
  value,
  onValueChange,
  text,
  onTextChange,
  title,
  label,
}) {
  return (
    <div
      css={css`
        flex-basis: 50%;

        @media (max-width: 700px) {
          flex-basis: 100%;
        }
      `}
    >
      <Text
        variant="h6"
        fontWeight="700"
        css={css`
          min-height: 64px;
        `}
      >
        {title}
      </Text>
      <RadioGroup value={value}>
        <div
          css={css`
            display: flex;
            gap: 1rem;
            flex-direction: column;
            margin-bottom: ${value !== 'other' ? '72px' : '0'};

            @media (max-width: 700px) {
              margin-bottom: 0;
            }
            width: 100%;
          `}
        >
          {options.map((option, idx) => (
            <div
              css={css`
                border: 1px solid #0000003b;
                border-radius: 8px;
                padding: 1rem;
                cursor: pointer;

                display: flex;
                justify-content: space-between;
                align-items: center;
              `}
              onClick={() => onValueChange(option.value)}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                `}
              >
                <div
                  css={css`
                    background-color: #00000014;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    border-radius: 50%;
                  `}
                >
                  <option.icon />
                </div>
                <Text>{option.title}</Text>
              </div>
              <div>
                <Radio
                  checked={value === option.value}
                  css={css`
                    padding: 0;
                  `}
                  onChange={(e) => {
                    onValueChange(option.value);
                  }}
                />
              </div>
            </div>
          ))}
          {value === 'other' && (
            <TextField
              value={text}
              onChange={(e) => onTextChange(e.target.value)}
              label={label}
              autoComplete="off"
              autoFocus
              size="small"
            />
          )}
        </div>
      </RadioGroup>
    </div>
  );
}
